// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../css-loader/index.js!./ol.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../vue-style-loader/lib/addStylesClient.js")("50ba8517", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/ol.css
// module id = 224
// module chunks = 0